// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"_21soYIr1xw","breadcrumbs-container":"FHypPd522a","breadcrumbsContainer":"FHypPd522a"};
    if(module.hot) {
      // 1625219450030
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  